<template>
    <div class="col-lg-4 col-md-6">
        <div class="product-card product_container">
            <a class="product-card__link" :href="product.url">


                <span v-if="product.sale" class="product-card__sale">akcija</span>


                <div class="product-card__image">

                    <img class="product_main_image product-card__img"
                         :src="APP_URL+'/images/'+product.image" alt="">
                </div>
                <div class="product-card__header">
                    <h3 class="product-card__title">
                        {{product.name}}
                    </h3>
                </div>
                <div class="product-card__body">
                    <div class="product-card__desc">
                        {{ product.intro_text}}
                    </div>
                    <div class="product-card__price">
                        <span v-if="product.price !== '0.00'">od {{product.price}}</span>
                        <span v-else>Na upit</span>
                    </div>
                </div>
            </a>

        </div>
    </div>
</template>

<script>
    export default {
        name: "ProductCardComponent",
        data() {
            return {
                APP_URL: APP_URL
            }
        },
        props: [
            'product'
        ],
        methods:{
            handleAddToCartNEW(id){

                this.$parent.handleAddToCart(id);
            },
        }
    }
</script>

<style scoped>

</style>


// WEBPACK FOOTER //
// resources/assets/js/components/ProductCardComponent.vue